/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetProfilesResponse
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetApiWebCalendarGetProfilesUrl = () => {




  return `/api/WebCalendar/GetProfiles`
}

export const getApiWebCalendarGetProfiles = async ( options?: Parameters<typeof customInstance>[1]): Promise<GetProfilesResponse> => {

  return customInstance<GetProfilesResponse>(getGetApiWebCalendarGetProfilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWebCalendarGetProfilesQueryKey = () => {
    return [
    `/api/WebCalendar/GetProfiles`
    ] as const;
    }


export const getGetApiWebCalendarGetProfilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarGetProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>> = ({ signal }) => getApiWebCalendarGetProfiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWebCalendarGetProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>>
export type GetApiWebCalendarGetProfilesQueryError = ErrorType<unknown>


export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWebCalendarGetProfiles<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWebCalendarGetProfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiWebCalendarGetProfilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarGetProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>> = ({ signal }) => getApiWebCalendarGetProfiles({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetApiWebCalendarGetProfilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>>
export type GetApiWebCalendarGetProfilesSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWebCalendarGetProfilesSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarGetProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWebCalendarGetProfilesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiWebCalendarExportIdNameUrl = (id: string,
    name: string,) => {




  return `/api/WebCalendar/export/${id}/${name}`
}

export const getApiWebCalendarExportIdName = async (id: string,
    name: string, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getGetApiWebCalendarExportIdNameUrl(id,name),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWebCalendarExportIdNameQueryKey = (id: string,
    name: string,) => {
    return [
    `/api/WebCalendar/export/${id}/${name}`
    ] as const;
    }


export const getGetApiWebCalendarExportIdNameQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdNameQueryKey(id,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>> = ({ signal }) => getApiWebCalendarExportIdName(id,name, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWebCalendarExportIdNameQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>>
export type GetApiWebCalendarExportIdNameQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>,
          TError,
          Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWebCalendarExportIdName<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWebCalendarExportIdNameQueryOptions(id,name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiWebCalendarExportIdNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebCalendarExportIdNameQueryKey(id,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>> = ({ signal }) => getApiWebCalendarExportIdName(id,name, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetApiWebCalendarExportIdNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>>
export type GetApiWebCalendarExportIdNameSuspenseQueryError = ErrorType<unknown>


export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWebCalendarExportIdNameSuspense<TData = Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError = ErrorType<unknown>>(
 id: string,
    name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiWebCalendarExportIdName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWebCalendarExportIdNameSuspenseQueryOptions(id,name,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






